import { render, staticRenderFns } from "./VeJwCjyjList.vue?vue&type=template&id=34554c2e&scoped=true"
import script from "./VeJwCjyjList.vue?vue&type=script&lang=js"
export * from "./VeJwCjyjList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34554c2e",
  null
  
)

export default component.exports